import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import axios from 'axios';

import RefillList from './RefillsList';
import { SET_REFILLS } from '../../ActionTypes/ActionTypes';

class PendingRefills extends Component {
    state = {
        loading: false,
    }

    componentDidMount =() => {
        const { setRefills } = this.props;

        this.setState({ loading: true });
        axios({
            method: 'get',
            url: '/carefills/carefills_by_status.json?status=Pending',
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then((response) => {
                // this.forceUpdate();
                // setRefills(response.data.carefills);
                const pending_calls = response.data.carefills;

                // get calls who has not been responded yet
                axios({
                    method: 'get',
                    url: '/carefills/backlog_calls.json',
                    headers: { Authorization: sessionStorage.getItem('jwtToken') },
                })
                    .then((resp) => {
                        const backlogs = resp.data.carefills;
                        setRefills([...pending_calls, ...backlogs]);
                    });

                this.setState({
                    loading: false,
                });
            });
    }

    render() {
        const { loading } = this.state;
        return (
            <div>
                {
                    loading
                        ? <Spin />
                        : <RefillList />
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    refillsList: state.RefillState.refillsList,
});

const mapDispatchToProps = dispatch => ({
    setRefills: data => dispatch({ type: SET_REFILLS, payload: { data } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PendingRefills);



// WEBPACK FOOTER //
// ./src/component/RefillManagementSystem/PendingRefills.js